export function handleWindowPrint(ele,picArr) {
    if(drawEchartImg(picArr)){
        var content=initContent(ele);

        var w, doc, iframe = document.createElement('iframe'),
        f = document.body.appendChild(iframe);
    
        iframe.id = "myIframe";
        iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
        w = f.contentWindow || f.contentDocument;
        doc = f.contentDocument || f.contentWindow.document;
        doc.open();
        doc.write(content);
        doc.close();
        iframe.onload = function () {
            toPrint(w);
            setTimeout(function () {
                document.body.removeChild(iframe);
                deleteImg(picArr);
            }, 100)
        }
        return true;
    }
}
/**
 * 项目用到echarts，需要获取图片，来打印
 * @param {Object} doc iframe window
 */
export function drawEchartImg(picArr) {
    picArr.forEach(element => {
        var dom = document.getElementById(element)
        var domimg = document.getElementById(element+'img')
        let canvas = dom.getElementsByTagName("canvas")[0];
    
        if(canvas==undefined){
            return false;
        }
        let dataURL = canvas.toDataURL("image/png"); //转图片  隐藏canvas
        var img = new Image();
        img.src =dataURL;
        dom.style.display="none";
        domimg.appendChild(img);
    });
    return true;
}
export function deleteImg(picArr){
    picArr.forEach(element => {
        document.getElementById(element+"img").innerHTML="";
        document.getElementById(element).style.display="block";
    });
}
export function initContent(ele){
    var content = '<html><head><meta charset="utf-8">\n' +
    ' <title></title>\n' +
    ' <meta name="format-detection" content="telephone=no">\n' +
    ' <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">\n' +
    ' <meta name="viewport" content="width=device-width,initial-scale=1.0">\n' +
    ' <base href="/"><link rel="stylesheet" href="'+window.configuration.resourceUrlWeb+'static/day.css"/></head><body>';  //生成pdf的外部css样式
    content+=  document.querySelector( ele ).outerHTML+"</body>";
    return content;
}

/**打印*/
function toPrint (frameWindow) {
    try {
        setTimeout(function () {
            frameWindow.focus();
            try {
                frameWindow.print();
            } catch (e) {
                frameWindow.print();
            }
            frameWindow.close();
        }, 10);
    } catch (err) {
        console.log('err', err);
    }
}


// WEBPACK FOOTER //
// ./static/print.js